export default {
    data: () => ({
        translations: {
            addExternalLink: {
                el: "Προσθήκη Εξωτερικού Συνδέσμου",
                en: "Add External Link",
                it: "Aggiungi Link Esterno"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            image: {
                el: "Εικόνα",
                en: "Image",
                it: "Immagine"
            },
            link: {
                el: "Σύνδεσμος",
                en: "Link",
                it: "Link"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
        }
    })
};
